import React from 'react';
import { Select, type SelectOption } from '../../../../../../../components';

type PanelResultProps = {
  applicationId: string;
  panelResult: string;
  disabled: boolean;
  triggerRender: number;
  panelResultOptions: SelectOption[];
  handleChangePanelResult: (
    applicationId: string,
    panelResult: string,
  ) => Promise<void>;
};

const PanelResult: React.FunctionComponent<PanelResultProps> = (
  props: PanelResultProps,
) => {
  const {
    applicationId,
    panelResult,
    triggerRender,
    disabled,
    panelResultOptions,
    handleChangePanelResult,
  } = props;

  return (
    <div key={triggerRender}>
      {disabled ? (
        <>
          {' '}
          {panelResultOptions.find(op => op.value === panelResult)?.label ?? ''}
        </>
      ) : (
        <Select
          key={applicationId}
          options={panelResultOptions}
          size="small"
          value={panelResult ?? ''}
          fullWidth
          disabled={disabled}
          onChange={async e => {
            await handleChangePanelResult(applicationId, e.target.value);
          }}
        />
      )}
    </div>
  );
};
const MemoizedPanelResult = React.memo(PanelResult);
export { MemoizedPanelResult };
